import { Toast } from 'antd-mobile';
import axios, { AxiosError } from 'axios';
import { isApp } from '../utils/EnvUtils';
import { JsBridge } from '../utils/JsBridge'; // 从 index.tsx 导入 tokenPromise

const _host = 'https://api.sduck.net';
const _hostTest = 'https://testy6.sduck.net';
const _baseUrl = window.location.host === 'sduck.net' ? _host : _hostTest;
// const _baseUrl = _host;
// const _baseUrl = "http://192.168.31.164:8080/";

export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  msg?: string;
  result: string;
}

export function getApiBaseHost(): string {
  return _baseUrl;
}

export function getWebBaseHost(): string {
  console.log('window.location.origin', window.location.origin);
  return window.location.origin;
  // return "https://sduck.net";
  // return "http://192.168.31.236:8000";
}

export const axiosInstance = axios.create({
  baseURL: _baseUrl,
});

// 添加请求拦截器来动态设置 token，并确保等待 token
axiosInstance.interceptors.request.use(
  async function (config) {
    let userAgent = navigator.userAgent;
    const authMatch = userAgent.match(/Authorization_Bearer\s([^\s]+)/);
    if (authMatch && authMatch[1]) {
      const token = authMatch[1];
      config.headers.authorization = `Bearer ${token}`;
    }
    
    const appIdMatch = userAgent.match(/X-App-Id_([^\s]+)/);
    if (appIdMatch && appIdMatch[1]) {
      const appId = appIdMatch[1];
      config.headers['X-App-Id'] = appId;
    }
    //mock
    // config.headers.authorization =
    //   'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOjEzNDgzNTEsIm1pZCI6NDI3LCJleHAiOjE3NjE4NzY0NTJ9.LDtJizrchvaMkx8ouLT75QhddUBD6KYI6Tp6LJKw8hE';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

const _nativeDecrypt = (data: string) => {
  return new Promise(resolve => {
    JsBridge.nativeDecrypt(data, (args: string) => {
      console.log('args', args);
      resolve(args);
    });
  });
};

axiosInstance.interceptors.response.use(
  async function (response) {
    // 生产解密
    if (
      _baseUrl.startsWith(_host) &&
      response?.data?.data &&
      response?.data?.eType === 1
    ) {
      const _decryptData = await _nativeDecrypt(response?.data?.data);
      response.data.data = _decryptData;
    }
    return response;
  },
  function (error) {
    console.error(error.response?.status, error.response?.config?.url);
    if (error.response?.status === 401) {
      JsBridge.gotoLogin({ sourceFrom: 'h5' });
      return;
    }
    // if (error.response?.status === 400) {
    //   return error.response
    // }
    return Promise.reject(error);
  }
);

/**
 * 发起 GET 基础请求，包含自己服务端约定格式数据的基本逻辑处理，第三方的请求不要调用该基础请求
 * @template T - 响应数据的类型
 * @param {string} url 请求的 URL
 * @param {Record<string, any>} params 请求的参数
 * @returns {Promise<{success: boolean, data?: T, msg?: string, code?: number}>} 返回一个包含结果的 Promise 对象
 */
export async function requestGet<T>(
  url: string,
  params: Record<string, any>
): Promise<{
  success: boolean;
  data?: T;
  msg?: string;
  result?: string;
  code?: number;
}> {
  try {
    const response = await axiosInstance.get(url, { params: params });

    if (response.status === 200 && response.data?.result === 'SUCCESS') {
      return {
        success: true,
        data: response.data.data,
        msg: response.data?.msg ?? '请求成功',
        code: response.status,
        result: response.data?.result,
      };
    } else {
      return {
        success: false,
        msg: response.data?.msg ?? '请求失败',
        code: response.status,
        result: response.data?.result,
      };
    }
  } catch (error) {
    if (error instanceof AxiosError && error.response) {
      // 服务器返回了响应，但状态码不是 2xx
      return {
        success: false,
        msg: error?.response?.data?.msg ?? '请求失败',
        code: error?.response?.status ?? 500,
        result: error?.response?.data?.result,
      };
    } else {
      // 请求已发出，但没有收到响应
      return {
        success: false,
        msg: '网络错误，请检查网络连接',
        code: 500,
        result: 'ERROR',
      };
    }
  }
}

// export function requestPost<T>(
//   url: string,
//   data?: any
// ): Promise<ApiResponse<T>> {
//   return axiosInstance.post(url, data).then((response) => response.data);
// }

export async function requestPost<T>(
  url: string,
  data?: any,
  params?: Record<string, any>
): Promise<{
  success: boolean;
  data?: T;
  msg?: string;
  result?: string;
  code?: number;
}> {
  try {
    const response = await axiosInstance.post(url, data, { params: params });
    if (response.status === 200 && response.data?.result === 'SUCCESS') {
      return {
        success: true,
        data: response.data.data,
        msg: response.data?.msg ?? '请求成功',
        code: response.status,
        result: response.data?.result,
      };
    } else {
      return {
        success: false,
        msg: response.data?.msg ?? '请求失败',
        code: response.status,
        result: response.data?.result,
      };
    }
  } catch (error) {
    if (error instanceof AxiosError && error.response) {
      // 服务器返回了响应，但状态码不是 2xx
      return {
        success: false,
        msg: error?.response?.data?.msg ?? '请求失败',
        code: error?.response?.status ?? 500,
        result: error?.response?.data?.result,
      };
    } else {
      // 请求已发出，但没有收到响应
      return {
        success: false,
        msg: '网络错误，请检查网络连接',
        code: 500,
        result: 'ERROR',
      };
    }
  }
}
